import { apiGet, apiPost, apiPut, apiDelete } from './api'
import type { Project, ProjectCreate, ProjectUpdate, ProjectQueryParams, PagedResult } from '../types'

function buildQueryString(params: ProjectQueryParams): string {
  const parts: string[] = []
  if (params.search) parts.push(`search=${encodeURIComponent(params.search)}`)
  if (params.status) parts.push(`status=${encodeURIComponent(params.status)}`)
  if (params.page !== undefined) parts.push(`page=${params.page}`)
  if (params.pageSize !== undefined) parts.push(`pageSize=${params.pageSize}`)
  if (params.sortBy) parts.push(`sortBy=${encodeURIComponent(params.sortBy)}`)
  if (params.sortDirection) parts.push(`sortDirection=${params.sortDirection}`)
  return parts.length > 0 ? `?${parts.join('&')}` : ''
}

export const projectApi = {
  getAll(params: ProjectQueryParams = {}): Promise<PagedResult<Project>> {
    return apiGet<PagedResult<Project>>(`/projects${buildQueryString(params)}`)
  },

  getById(id: string): Promise<Project> {
    return apiGet<Project>(`/projects/${id}`)
  },

  create(data: ProjectCreate): Promise<Project> {
    return apiPost<Project>('/projects', data)
  },

  update(id: string, data: ProjectUpdate): Promise<Project> {
    return apiPut<Project>(`/projects/${id}`, data)
  },

  delete(id: string): Promise<void> {
    return apiDelete(`/projects/${id}`)
  },
}
